import { number } from "prop-types";

function runningCount(
    state = {
        count: number,
    },
    action
) {
    switch (action.type) {
        case "SET_RUNNING_COUNT":
            return {
                count: action.count,
            };
        default:
            return state;
    }
}
export default runningCount;
